import { Controller } from "@hotwired/stimulus"
import Tablesort from "tablesort"

// Connects to data-controller="tablesort"
export default class extends Controller {
  connect() {
    this.sort = new Tablesort(this.element)
  }
}
